var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-overlay',[_c('rkm-container',{staticClass:"rkm-container",attrs:{"fluid":""}},[(_vm.loaded)?_c('rkm-row',[_c('rkm-col',{attrs:{"cols":"12"}},[_c('Form',{staticClass:"mt-3"})],1)],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }